import React, { Component } from 'react'

import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';
import BooleanIcon from '../std/BooleanIcon';
import TableTitle from './TableTitle';

class TableServices extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	getHeaderTitle(name) {
		return this.props.developperView ? name : this.getMessage(`service.${name}`);
	}
	render() {
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				<TableTitle developperView={this.props.developperView} title={this.props.title} fieldname={this.props.fieldname} />
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								<th className='text-center'>{this.getHeaderTitle('selected')}</th>
								<th className='text-start'>{this.getHeaderTitle('serviceCode')}</th>
								<th className='text-start'>{this.getHeaderTitle('packageCode')}</th>
								<th className='text-start'>{this.getHeaderTitle('catSvc')}</th>
								<th className='text-start'>{this.props.developperView ? 'label' : this.getMessage('generics.label')}</th>
								<th className='text-end'>{this.getHeaderTitle('rental.amountExclTax')}</th>
								<th className='text-end'>{this.getHeaderTitle('rental.amountInclTax')}</th>
								<th className='text-end'>{this.getHeaderTitle('total.amountExclTax')}</th>
								<th className='text-end'>{this.getHeaderTitle('total.amountInclTax')}</th>
								<th className='text-end'>{this.getHeaderTitle('recapCode')}</th>
								<th className='text-end'>{this.getHeaderTitle('externalservicecode')}</th>
								<th className='text-end'>{this.getHeaderTitle('externalpackagecode')}</th>
							</tr>
						</thead>
						<tbody>
							{this.props.services.map((line, index) => (
								<tr key={index}>
									<td className='text-center'>
										<BooleanIcon developperView={this.props.developperView} value={line.selected} />
									</td>
									<td className='text-start'>{line.cdOptEki}</td>
									<td className='text-start'>{line.cdPack}</td>
									<td className='text-start'>{line.cdCatSvc}</td>
									<td className='text-start'>{line.label}</td>
									<td className='text-end'>{line.rental && (this.props.developperView ? line.rental.amountExclTax
										: Dico.getAmountFormatted(line.rental, 'HT', this.props.context.countryCode, this.props.context.languageCode))}</td>
									<td className='text-end'>{line.rental && (this.props.developperView ? line.rental.amountInclTax
										: Dico.getAmountFormatted(line.rental, 'TC', this.props.context.countryCode, this.props.context.languageCode))}</td>
									<td className='text-end'>{line.total && (this.props.developperView ? line.total.amountExclTax
										: Dico.getAmountFormatted(line.total, 'HT', this.props.context.countryCode, this.props.context.languageCode))}</td>
									<td className='text-end'>{line.total && (this.props.developperView ? line.total.amountInclTax
										: Dico.getAmountFormatted(line.total, 'TC', this.props.context.countryCode, this.props.context.languageCode))}</td>
									<td className='text-end'>{line.recapCode}</td>
									<td className='text-end'>{line.externalservicecode}</td>
									<td className='text-end'>{line.externalpackagecode}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableServices)
